import { RouteFactory } from "@app/routePaths";
import { AwardsMenu } from "@events-awards/utils/types";
import { TabItem } from "@hooks/useTabs";

export const SCA_FOOTER_MENU = [
  {
    label: "About",
    link: RouteFactory.scaAboutPage,
  },
  {
    label: "Awards",
    link: RouteFactory.scaAwardsPage,
  },
  {
    label: "Winners",
    link: RouteFactory.eventsAwardsWinners("singapore-corporate-awards"),
  },
  {
    label: "News",
    link: RouteFactory.eventsAwardsNews("singapore-corporate-awards"),
  },
  {
    label: "Gallery",
    link: RouteFactory.eventsAwardsNews("singapore-corporate-awards"),
  },
  {
    label: "How to Nominate",
    link: RouteFactory.scaNominatePage,
  },
  {
    label: "Contact Us",
    link: RouteFactory.scaContactUsPage,
  },
  {
    label: "FAQ",
    link: RouteFactory.scaFaqPage,
  },
  {
    label: "Partners",
    link: RouteFactory.scaPartnersPage,
  },
];

export const SCA_NAVIGATION_ITEMS: AwardsMenu[] = [
  {
    text: "About",
    link: RouteFactory.scaAboutPage,
    enabled: true,
  },
  {
    text: "Awards",
    link: RouteFactory.scaAwardsPage,
    enabled: true,
  },
  {
    text: "Winners",
    link: RouteFactory.eventsAwardsWinners("singapore-corporate-awards"),
    enabled: true,
  },
  {
    text: "News",
    link: RouteFactory.eventsAwardsNews("singapore-corporate-awards"),
    enabled: true,
  },
  {
    text: "Gallery",
    link: RouteFactory.eventsAwardsGallery("singapore-corporate-awards"),
    enabled: true,
  },
  {
    text: "How to Nominate",
    link: RouteFactory.scaNominatePage,
    enabled: true,
  },
];

export const NOMINATIONS_TAB: TabItem[] = [
  {
    key: "nominationsTab",
    label: "Nominations",
  },
  {
    key: "eligibilityTab",
    label: "Eligibility",
  },
  {
    key: "selectionsTab",
    label: "Selections",
  },
];

export const AWARDS_TAB: TabItem[] = [
  {
    key: "best-managed-board",
    label: "Best Managed Board",
  },
  {
    key: "best-chief-executive-officer",
    label: "Best Chief Executive Officer",
  },
  {
    key: "best-chief-financial-officer",
    label: "Best Chief Financial Officer",
  },
  {
    key: "best-risk-management",
    label: "Best Risk Management",
  },
  {
    key: "best-investors-relations",
    label: "Best Investors Relations",
  },
  {
    key: "best-annual-report",
    label: "Best Annual Report",
  },
  {
    key: "special-recognition-award",
    label: "Special Recognition Award",
  },
  {
    key: "distinguished-distribution",
    label: "Distinguished Contribution to Corporate Governance Award",
  },
  {
    key: "special-edition",
    label:
      "The SCA Special Edition 2020/2021 - Corporate Excellence & Resilience Award",
  },
];
